import { useQuery } from '@tanstack/react-query';

import { dataService, type ExteriorImprovementsReportParams } from '@/services/data-service';

export const exteriorImprovementsReportKey = (params: ExteriorImprovementsReportParams) =>
	['exterior-improvements-report', params] as const;

/** Summary or full-packet report; idle until a range is chosen. */
export const useExteriorImprovementsReport = (params: ExteriorImprovementsReportParams | null) =>
	useQuery({
		queryKey: params ? exteriorImprovementsReportKey(params) : ['exterior-improvements-report', 'idle'],
		queryFn: () => dataService.getExteriorImprovementsReport(params as ExteriorImprovementsReportParams),
		enabled: !!params,
		placeholderData: (previous) => previous,
	});
